var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, IconButton, MenuItem, Select, Switch, Tooltip } from "@mui/material";
import parse from "node-html-parser";
import FormatAlignLeftRoundedIcon from "@mui/icons-material/FormatAlignLeftRounded";
import FormatAlignRightRoundedIcon from "@mui/icons-material/FormatAlignRightRounded";
import FormatAlignCenterRoundedIcon from "@mui/icons-material/FormatAlignCenterRounded";
import FormatBoldRoundedIcon from "@mui/icons-material/FormatBoldRounded";
import FormatUnderlinedRoundedIcon from "@mui/icons-material/FormatUnderlinedRounded";
import FormatItalicRoundedIcon from "@mui/icons-material/FormatItalicRounded";
import FormatListBulletedRoundedIcon from "@mui/icons-material/FormatListBulletedRounded";
import FormatListNumberedRoundedIcon from "@mui/icons-material/FormatListNumberedRounded";
import AddPhotoAlternateRoundedIcon from "@mui/icons-material/ImageRounded";
import VideoCameraBackRoundedIcon from "@mui/icons-material/VideoCameraBackRounded";
import AudioFileRoundedIcon from "@mui/icons-material/AudioFileRounded";
import $ from "jquery";
import "jquery-ui-bundle";
import "jquery-ui-bundle/jquery-ui.css";
// import "../../styleSheets/richTextEditorResizeImageAnimationStyleSheet.css";
// @import url('https://fonts.googleapis.com/css?family=Roboto');
import { useEffect, useRef, useState } from "react";
import { removeRteContainerDivFromHTMLString } from "../../utils/removeRteContainerDivFromHTMLString";
import { encodeCharacterEscapedHTML } from "../../utils/encodeCharacterEscapedHTML";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { v4 as uuid } from "uuid";
var SelectedAlignOption;
(function (SelectedAlignOption) {
    SelectedAlignOption[SelectedAlignOption["LEFT"] = 0] = "LEFT";
    SelectedAlignOption[SelectedAlignOption["MIDDLE"] = 1] = "MIDDLE";
    SelectedAlignOption[SelectedAlignOption["RIGHT"] = 2] = "RIGHT";
})(SelectedAlignOption || (SelectedAlignOption = {}));
var SelectedTextFormatOption;
(function (SelectedTextFormatOption) {
    SelectedTextFormatOption[SelectedTextFormatOption["BOLD"] = 0] = "BOLD";
    SelectedTextFormatOption[SelectedTextFormatOption["ITALIC"] = 1] = "ITALIC";
    SelectedTextFormatOption[SelectedTextFormatOption["UNDERLINE"] = 2] = "UNDERLINE";
})(SelectedTextFormatOption || (SelectedTextFormatOption = {}));
var SelectedListOption;
(function (SelectedListOption) {
    SelectedListOption[SelectedListOption["UNORDERED"] = 0] = "UNORDERED";
    SelectedListOption[SelectedListOption["ORDERED"] = 1] = "ORDERED";
})(SelectedListOption || (SelectedListOption = {}));
export var ImageResizeMode;
(function (ImageResizeMode) {
    ImageResizeMode[ImageResizeMode["GHOST"] = 0] = "GHOST";
    ImageResizeMode[ImageResizeMode["NORMAL"] = 1] = "NORMAL";
})(ImageResizeMode || (ImageResizeMode = {}));
export function htmlToSource(selector) {
    return $("<div />").append($(selector).clone()).html();
}
function setFocusToMessageBox() {
    // @ts-ignore
    document.getElementById(richTextEditorId.current).focus();
}
function loseFocusToMessageBox() {
    // @ts-ignore
    document.getElementById(richTextEditorId.current).blur();
}
function modifyText(commandName, val) {
    return document.execCommand(commandName, false, val);
}
export var DragContentOptions;
(function (DragContentOptions) {
    DragContentOptions["IMAGE"] = "images";
    DragContentOptions["IMAGE_360"] = "three_sixty_image";
    DragContentOptions["AUDIO"] = "audio";
    DragContentOptions["VIDEO"] = "video";
    DragContentOptions["VIDEO_360"] = "three_sixty_video";
    DragContentOptions["MODEL_3D"] = "three_d_model";
    DragContentOptions["MOVEMENT"] = "movement";
    DragContentOptions["INFORMATION"] = "information";
    DragContentOptions["ANSWER"] = "answer";
    DragContentOptions["QUESTION"] = "question";
    DragContentOptions["INTERFACE"] = "interface";
    DragContentOptions["SCENE"] = "scene";
})(DragContentOptions || (DragContentOptions = {}));
export function moveCursorToEnd(id) {
    var el = document.getElementById(id);
    el.focus();
    // select all the content in the element
    document.execCommand("selectAll", false);
    // collapse selection to the end
    document.getSelection().collapseToEnd();
}
export function VTRichTextEditor(_a) {
    // const [htmlVal, setHtmlVal] = useState<string>(startingHtmlContent);
    //   const [fontSize, setFontSize] = useState<number>(4);
    var sx = _a.sx, _b = _a.startingHtmlContent, startingHtmlContent = _b === void 0 ? "" : _b, 
    // controlledInputType = "non-controlled",
    _c = _a.onDropImagePxWidthForRatio, 
    // controlledInputType = "non-controlled",
    onDropImagePxWidthForRatio = _c === void 0 ? 200 : _c, onClickImageIcon = _a.onClickImageIcon, onClickVideoIcon = _a.onClickVideoIcon, onClickAudioIcon = _a.onClickAudioIcon, _d = _a.focusOnMount, focusOnMount = _d === void 0 ? false : _d, _e = _a.imageResizeMode, imageResizeMode = _e === void 0 ? ImageResizeMode.GHOST : _e, onChange = _a.onChange, currentlyDragging = _a.currentlyDragging, save = _a.save, cancel = _a.cancel;
    var richTextEditorId = useRef("rich-text-editor-".concat(uuid()));
    var _f = __read(useState(4), 2), fontSize = _f[0], setFontSize = _f[1];
    var _g = __read(useState(null), 2), selectedAlignButtonOption = _g[0], setSelectedAlignButtonOption = _g[1];
    var _h = __read(useState(null), 2), selectedFormatOption = _h[0], setSelectedFormatOption = _h[1];
    var _j = __read(useState(null), 2), selectedListOption = _j[0], setSelectedListOption = _j[1];
    var _k = __read(useState(false), 2), fontSizeToolTipOpen = _k[0], setFontSizeToolTipOpen = _k[1];
    var _l = __read(useState(true), 2), rawHTMLToggleChecked = _l[0], setRawHTMLToggleChecked = _l[1];
    var currentSelectedImgIdRef = useRef(null);
    var imgIdsRef = useRef(null);
    var editAreaRef = useRef(null);
    var _m = __read(useState(startingHtmlContent), 2), rawHtml = _m[0], setRawHtml = _m[1];
    var mouseOverContentEditableAreaRef = useRef(false);
    // useEffect(() => {
    //     window.setInterval(() => {
    //     }, 1000);
    // }, []);
    useEffect(function () {
        setRawHtml(startingHtmlContent);
    }, [startingHtmlContent]);
    var _o = __read(useState(false), 2), imgIsCurrentlySelected = _o[0], setImgIsCurrentlySelected = _o[1];
    function onChangeHandler(shouldEncodeCharacterEscapedHTML) {
        window.setTimeout(function () {
            var richTextEditorHTMLContent = "";
            var $richTextEditorContainer = $("#".concat(richTextEditorId.current));
            var $richTextEditorContentContainer = $richTextEditorContainer.find(".rte-container");
            // if <div class='rte-container'> </div> is in htmlInitialContent, extract data out of it
            // if ($richTextEditorContentContainer.length > 0) {
            //     richTextEditorHTMLContent = $richTextEditorContentContainer.html();
            // } else {
            richTextEditorHTMLContent = $richTextEditorContainer.html();
            if (shouldEncodeCharacterEscapedHTML)
                richTextEditorHTMLContent = encodeCharacterEscapedHTML(richTextEditorHTMLContent);
            // }
            // }
            var domTreeAsArray = $.parseHTML("<div class=\"rte-container\"> ".concat(richTextEditorHTMLContent, " </div>"));
            var $rootSelector = $(domTreeAsArray[0]);
            if ($rootSelector.find(".ui-wrapper").length !== 0) {
                var $imgSelector = $rootSelector.find(".ui-wrapper").find("img");
                $imgSelector.css({ border: "", display: "" });
                $imgSelector.removeClass("imageResizeBorder");
                $rootSelector.find(".ui-wrapper").replaceWith($imgSelector);
            }
            $rootSelector.find("img").css({ cursor: "" });
            $rootSelector.find("img").css({ position: "relative" });
            var marshedHTMLString = htmlToSource($($rootSelector));
            // rawHtmlRef.current = marshedHTMLString;
            onChange && onChange(marshedHTMLString);
        }, 250);
    }
    var dropInProgressRef = useRef(false);
    // const alreadyFoundNewImageRef = use
    function onDropHandler() {
        // e.preventDefault();
        // currentSelectedImgIdRef.current = null; // if an image was previously selected for image resize -
        // before htmlContent prop change make sure to -
        // get rid of a reference to it in memory, so code doesn't try to call resize destroy(jquery) on something that -
        // is no longer in the DOM
        // console.log("ON DROP HANDLER CODE FIRED");
        deselectImage();
        window.setTimeout(function () {
            // if (!dropInProgressRef.current) {
            //     dropInProgressRef.current = true;
            var $richTextEditorHTMLContent = $("#".concat(richTextEditorId.current));
            $richTextEditorHTMLContent.find("img").each(function (i, imgElement) {
                // console.log("FOR EACH FIRED", i);
                var $imgSelector = $(imgElement);
                if (imgElement.id === "") {
                    if (!dropInProgressRef.current) {
                        dropInProgressRef.current = true;
                        var imgId = "I_" + Math.floor(Math.random() * 100000);
                        $imgSelector.attr("id", imgId);
                        $imgSelector.attr("class", "rte-image");
                        // const imageWidth = onDropImagePxWidthForRatio;
                        // const newImageHeightPreserveRatio = getPreserveRatioHeightGivenWidth(
                        //     $imgSelector.height()!,
                        //     $imgSelector.width()!,
                        //     imageWidth,
                        // );
                        // $imgSelector.css("all", "unset"); bad way
                        $imgSelector.removeAttr("style"); // good way
                        $imgSelector.removeAttr("width");
                        $imgSelector.css({
                            width: "".concat(200, "px"),
                            height: "".concat(200, "px"),
                            "object-fit": "cover"
                        });
                        if (imgIdsRef.current == null) {
                            imgIdsRef.current = [];
                        }
                        imgIdsRef.current.push(imgId);
                        attachImgEventHandlers();
                        moveCursorToEnd(richTextEditorId.current);
                        window.setTimeout(function () {
                            dropInProgressRef.current = false;
                        });
                    }
                    else {
                        $imgSelector.remove();
                    }
                }
                else if (imgElement.id === "video-drop-img") {
                    var vidId = "v_" + Math.floor(Math.random() * 1000000);
                    // let videoSrc = onVideoDroppedSrc && onVideoDroppedSrc();
                    $imgSelector.replaceWith("<div> <div> <video style=\"user-select: auto; width: 100%;\" id=\"".concat(vidId, "\" controls draggable=\"true\"> <source src=\"").concat(currentlyDragging === null || currentlyDragging === void 0 ? void 0 : currentlyDragging.src, "\" type=\"video/mp4\"> </video> </div> <br /> </div>"));
                    // $imgSelector.removeAttr("style"); // good way
                    // const $vidSelector = $(`#${vidId}`);
                    // $vidSelector.attr("position", "relative");
                    // $vidSelector.css({
                    //     width: `350px`,
                    //     // border: "3px solid lime"
                    //     // height: `180px`,
                    // });
                }
                else if (imgElement.id === "audio-drop-img") {
                    var audioId = "a_" + Math.floor(Math.random() * 1000000);
                    // let audioSrc = onAudioDroppedSrc && onAudioDroppedSrc();
                    $imgSelector.replaceWith("<div><div style=\"display:inline-block;\"> <audio id=\"".concat(audioId, "\" controls src=\"").concat(currentlyDragging === null || currentlyDragging === void 0 ? void 0 : currentlyDragging.src, "\" draggable=\"true\"/> </div> <br /> </div>"));
                }
                mouseOverContentEditableAreaRef.current = false;
            });
            // cannot drop any other media into rte for atleasy half a second (500ms)
            // }
        });
    }
    useEffect(function () {
        if (focusOnMount)
            editAreaRef.current.focus();
    }, []);
    useEffect(function () {
        currentSelectedImgIdRef.current = null; // if an image was previously selected for image resize -
        // before htmlContent prop change make sure to -
        // get rid of a reference to it in memory, so code doesn't try to call resize destroy(jquery) on something that -
        // is no longer in the DOM
        var parsedHTML = parse(startingHtmlContent);
        parsedHTML.getElementsByTagName("img").forEach(function (imgElement) {
            if (imgIdsRef.current == null)
                imgIdsRef.current = [];
            imgIdsRef.current.push(imgElement.id);
        });
        attachImgEventHandlers();
    }, [startingHtmlContent]);
    function attachImgEventHandlers() {
        window.setTimeout(function () {
            var _a;
            (_a = imgIdsRef.current) === null || _a === void 0 ? void 0 : _a.forEach(function (imgId) {
                var handler = function (e) { return onImgSelected(e, imgId); };
                $("#" + imgId).off("click", handler);
                $("#" + imgId).on("click", handler);
                $("#" + imgId).css({ cursor: "move" });
            }, 500);
        });
    }
    function deselectImage() {
        // e.stopPropagation();
        if (currentSelectedImgIdRef.current) {
            $("#" + currentSelectedImgIdRef.current).removeClass("imageResizeBorder");
            // @ts-ignore
            $("#" + currentSelectedImgIdRef.current).resizable("destroy");
            // @ts-ignore
            $("#" + currentSelectedImgIdRef.current).css("border", "none");
            $("#" + currentSelectedImgIdRef.current).css({ display: "" });
            $("#" + currentSelectedImgIdRef.current).attr("draggable", "true");
            $("#" + currentSelectedImgIdRef.current).css("cursor", "move");
            currentSelectedImgIdRef.current = null;
            setImgIsCurrentlySelected(false);
        }
    }
    function onImgSelected(e, imgId) {
        e.stopPropagation();
        loseFocusToMessageBox();
        // e.preventDefault();
        deselectImage();
        setImgIsCurrentlySelected(true);
        // focus img
        $("#" + currentSelectedImgIdRef.current).focus();
        window.setTimeout(function () {
            $("#" + currentSelectedImgIdRef.current).attr("draggable", "false");
            $("#" + currentSelectedImgIdRef.current).css("cursor", "no-drop");
        });
        currentSelectedImgIdRef.current = imgId;
        $("#" + currentSelectedImgIdRef.current).addClass("imageResizeBorder");
        // @ts-ignore
        $("#" + currentSelectedImgIdRef.current).resizable({
            ghost: imageResizeMode === ImageResizeMode.GHOST ? true : false,
            // containment: `#${richTextEditorId.current}`,
            handles: "se",
            aspectRatio: true,
            // @ts-ignore
            stop: function (event, ui) {
                var size = ui.size;
                var width = size.width, height = size.height;
                onChangeHandler();
            },
            resize: function (even, ui) {
                // currentImageResize.current?.updateResize();
            },
        });
        // grab ui-wrapper (img container) and add style display: "inline-blick"
        var $richTextEditorContainer = $("#".concat(richTextEditorId.current));
        var $jqueryUiWrapperOfImg = $richTextEditorContainer.find(".ui-wrapper");
        if ($jqueryUiWrapperOfImg.length > 0) {
            $jqueryUiWrapperOfImg.css({ display: "inline-block" });
        }
    }
    useEffect(function () {
        $(window).on("click", function (e) {
            deselectImage();
        });
        $(window).on("keydown", function (e) {
            if (currentSelectedImgIdRef.current) {
                if (e.key.toLocaleLowerCase() === "backspace" || e.key.toLocaleLowerCase() === "delete") {
                    e.preventDefault();
                    $("#" + currentSelectedImgIdRef.current).remove();
                    setImgIsCurrentlySelected(false);
                }
            }
        });
        $("#".concat(richTextEditorId.current)).on("input", function (e) {
            attachImgEventHandlers();
        });
    }, []);
    var _p = __read(useState(40), 2), buttonsPxSize = _p[0], setButtonsPxSize = _p[1];
    var rteContainerRef = useRef(null);
    function resizeButtons() {
        var _a;
        // @ts-ignore
        var containerWidth = (_a = rteContainerRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
        if (containerWidth) {
            if (containerWidth <= 505) {
                setButtonsPxSize(25);
            }
            else if (containerWidth <= 550) {
                setButtonsPxSize(30);
            }
            else if (containerWidth <= 600) {
                setButtonsPxSize(35);
            }
            else {
                setButtonsPxSize(40);
            }
        }
    }
    useEffect(function () {
        rteContainerRef.current = document.getElementById("rich-text-editor-container");
        if (rteContainerRef.current) {
            resizeButtons();
            new ResizeObserver(resizeButtons).observe(rteContainerRef.current);
        }
    }, []);
    return (_jsxs(Box, __assign({ id: "rich-text-editor-container", component: "div", sx: __assign({ height: "100%", borderRadius: "15px", background: "#333" }, sx), onInput: function (e) {
            // console.log("MOST OUTER INPUT FIRED");
        } }, { children: [_jsxs(Box, __assign({ component: "div", sx: { display: "flex", justifyContent: "space-between" } }, { children: [_jsxs(Box, __assign({ component: "div", sx: { display: "flex", alignItems: "center", padding: "5px" } }, { children: [_jsx(Tooltip, __assign({ open: fontSizeToolTipOpen, arrow: true, title: "Font Size" }, { children: _jsx(Select, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, onOpen: function () {
                                        setFontSizeToolTipOpen(false);
                                        setFocusToMessageBox();
                                    }, onMouseEnter: function () {
                                        setFontSizeToolTipOpen(true);
                                    }, onMouseLeave: function () {
                                        setFontSizeToolTipOpen(false);
                                    }, sx: {
                                        height: "".concat(buttonsPxSize, "px"),
                                        marginRight: "8px",
                                    }, labelId: "fontsize-select-label", id: "fontsize-select", value: fontSize, label: "fontsize", onChange: function (event) {
                                        var n = event.target.value;
                                        modifyText("fontSize", n);
                                        setFontSize(n);
                                    } }, { children: Array.from({ length: 7 }, function (_, i) { return i + 1; }).map(function (i) { return (_jsx(MenuItem, __assign({ value: i }, { children: i }))); }) })) })), _jsx(Tooltip, __assign({ arrow: true, title: "Bold Text" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, sx: __assign(__assign({}, (selectedFormatOption === SelectedTextFormatOption.BOLD && {
                                        backgroundColor: "#4f029c",
                                    })), { borderRadius: "3px", marginRight: "4px", width: "".concat(buttonsPxSize, "px"), height: "".concat(buttonsPxSize, "px") }), 
                                    //   action={}
                                    onClick: function (e) {
                                        modifyText("bold");
                                        setFocusToMessageBox();
                                    } }, { children: _jsx(FormatBoldRoundedIcon, {}) })) })), _jsx(Tooltip, __assign({ arrow: true, title: "Italic Text" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, sx: __assign(__assign({}, (selectedFormatOption === SelectedTextFormatOption.ITALIC && {
                                        backgroundColor: "#4f029c",
                                    })), { borderRadius: "3px", marginRight: "4px", width: "".concat(buttonsPxSize, "px"), height: "".concat(buttonsPxSize, "px") }), 
                                    //   action={}
                                    onClick: function () {
                                        modifyText("italic");
                                        setFocusToMessageBox();
                                    } }, { children: _jsx(FormatItalicRoundedIcon, {}) })) })), _jsx(Tooltip, __assign({ arrow: true, title: "Underline Text" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, sx: __assign(__assign({}, (selectedFormatOption === SelectedTextFormatOption.UNDERLINE && {
                                        backgroundColor: "#4f029c",
                                    })), { borderRadius: "3px", marginRight: "4px", width: "".concat(buttonsPxSize, "px"), height: "".concat(buttonsPxSize, "px") }), 
                                    //   action={}
                                    onClick: function () {
                                        modifyText("underline");
                                        setFocusToMessageBox();
                                    } }, { children: _jsx(FormatUnderlinedRoundedIcon, {}) })) })), _jsx(Divider, { sx: { marginLeft: "5px", marginRight: "8px" }, orientation: "vertical", flexItem: true }), _jsx(Tooltip, __assign({ arrow: true, title: "Justify Left" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked, sx: __assign(__assign({}, (selectedAlignButtonOption === SelectedAlignOption.LEFT && {
                                        backgroundColor: "#4f029c",
                                    })), { borderRadius: "3px", marginRight: "4px", width: "".concat(buttonsPxSize, "px"), height: "".concat(buttonsPxSize, "px") }), 
                                    //   action={}
                                    onClick: function (e) {
                                        setSelectedAlignButtonOption(SelectedAlignOption.LEFT);
                                        if (currentSelectedImgIdRef.current) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            var $selector = $("#" + currentSelectedImgIdRef.current);
                                            // if($selector.parent.
                                            if (["left", "center", "right"].includes($selector.parent().parent().css("text-align"))) {
                                                $selector.parent().parent().css({ textAlign: "left" });
                                            }
                                            else {
                                                $selector.parent().wrap("<div style=\"text-align: left;\"> </div>");
                                            }
                                        }
                                        else {
                                            modifyText("justifyLeft");
                                            setFocusToMessageBox();
                                        }
                                    } }, { children: _jsx(FormatAlignLeftRoundedIcon, {}) })) })), _jsx(Tooltip, __assign({ arrow: true, title: "Justify Middle" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked, sx: __assign(__assign({}, (selectedAlignButtonOption === SelectedAlignOption.MIDDLE && {
                                        backgroundColor: "#4f029c",
                                    })), { borderRadius: "3px", marginRight: "4px", width: "".concat(buttonsPxSize, "px"), height: "".concat(buttonsPxSize, "px") }), onClick: function (e) {
                                        setSelectedAlignButtonOption(SelectedAlignOption.MIDDLE);
                                        if (currentSelectedImgIdRef.current) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            var $selector = $("#" + currentSelectedImgIdRef.current);
                                            // if($selector.parent.
                                            if (["left", "center", "right"].includes($selector.parent().parent().css("text-align"))) {
                                                $selector.parent().parent().css({ textAlign: "center" });
                                            }
                                            else {
                                                $selector.parent().wrap("<div style=\"text-align: center;\"> </div>");
                                            }
                                        }
                                        else {
                                            modifyText("justifyCenter");
                                            setFocusToMessageBox();
                                        }
                                    } }, { children: _jsx(FormatAlignCenterRoundedIcon, {}) })) })), _jsx(Tooltip, __assign({ arrow: true, title: "Justify Right" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked, sx: __assign(__assign({}, (selectedAlignButtonOption === SelectedAlignOption.RIGHT && {
                                        backgroundColor: "#4f029c",
                                    })), { borderRadius: "3px", marginRight: "4px", width: "".concat(buttonsPxSize, "px"), height: "".concat(buttonsPxSize, "px") }), onClick: function (e) {
                                        setSelectedAlignButtonOption(SelectedAlignOption.RIGHT);
                                        if (currentSelectedImgIdRef.current) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            var $selector = $("#" + currentSelectedImgIdRef.current);
                                            // if($selector.parent.
                                            if (["left", "center", "right"].includes($selector.parent().parent().css("text-align"))) {
                                                $selector.parent().parent().css({ textAlign: "right" });
                                            }
                                            else {
                                                $selector.parent().wrap("<div style=\"text-align: right;\"> </div>");
                                            }
                                        }
                                        else {
                                            modifyText("justifyRight");
                                            setFocusToMessageBox();
                                        }
                                    } }, { children: _jsx(FormatAlignRightRoundedIcon, {}) })) })), _jsx(Divider, { sx: { marginLeft: "5px", marginRight: "8px" }, orientation: "vertical", flexItem: true }), _jsx(Tooltip, __assign({ arrow: true, title: "Unordered List" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, sx: __assign(__assign({}, (selectedListOption === SelectedListOption.UNORDERED && {
                                        backgroundColor: "#4f029c",
                                    })), { borderRadius: "3px", marginRight: "4px", width: "".concat(buttonsPxSize, "px"), height: "".concat(buttonsPxSize, "px") }), 
                                    //   action={}
                                    onClick: function () {
                                        modifyText("insertUnorderedList");
                                        setFocusToMessageBox();
                                    } }, { children: _jsx(FormatListBulletedRoundedIcon, {}) })) })), _jsx(Tooltip, __assign({ arrow: true, title: "Ordered List" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, sx: __assign(__assign({}, (selectedListOption === SelectedListOption.ORDERED && {
                                        backgroundColor: "#4f029c",
                                    })), { borderRadius: "3px", marginRight: "4px", width: "".concat(buttonsPxSize, "px"), height: "".concat(buttonsPxSize, "px") }), onClick: function () {
                                        modifyText("insertOrderedList");
                                        setFocusToMessageBox();
                                    } }, { children: _jsx(FormatListNumberedRoundedIcon, {}) })) })), _jsx(Divider, { sx: { marginLeft: "5px", marginRight: "8px" }, orientation: "vertical", flexItem: true }), _jsx(Tooltip, __assign({ arrow: true, title: "Add Image" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, id: "add-image", sx: {
                                        borderRadius: "3px",
                                        marginRight: "4px",
                                        width: "".concat(buttonsPxSize, "px"),
                                        height: "".concat(buttonsPxSize, "px"),
                                    }, onClick: function (e) {
                                        e.stopPropagation();
                                        // const imgId = "I_" + Math.floor(Math.random() * 100000);
                                        // if (imgIdsRef.current == null) imgIdsRef.current = [];
                                        // imgIdsRef.current.push(imgId);
                                        // let imgHTMLstr = `<img class="rte-image" id="${imgId}" width="150" height="100" src="${"https://virtus-ninja-dev.s3.eu-west-1.amazonaws.com/wales_virtual_hospital/images/68cd9255-3967-4ef5-8394-093436ad09ec.png"}" />`;
                                        // modifyText("insertHTML", imgHTMLstr);
                                        onClickImageIcon && onClickImageIcon();
                                    } }, { children: _jsx(AddPhotoAlternateRoundedIcon, {}) })) })), _jsx(Tooltip, __assign({ arrow: true, title: "Add Video" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, 
                                    // disabled={true}
                                    id: "add-video", sx: {
                                        borderRadius: "3px",
                                        marginRight: "4px",
                                        width: "".concat(buttonsPxSize, "px"),
                                        height: "".concat(buttonsPxSize, "px"),
                                    }, onClick: function (e) {
                                        //                 e.stopPropagation();
                                        //                 const imgId =
                                        //                     "I_" + Math.floor(Math.random() * 100000);
                                        //                 if (imgIdsRef.current == null)
                                        //                     imgIdsRef.current = [];
                                        //                 imgIdsRef.current.push(imgId);
                                        //                 // width="320" height="240"
                                        // let videoHTMLStr = `<span> </span> <video width="300" height="240" controls>
                                        //   <source
                                        //     src="${"https://virtus-tech-bls-media-dev.s3.eu-west-1.amazonaws.com/videos/scenario_3_shock.mp4"}"
                                        //     type="video/mp4">
                                        //   Your browser does not support the video tag.
                                        // </video>`;
                                        //                 // let imgHTMLstr = `<img class="rte-image" id="${imgId}" src="${
                                        //                 //   process.env.PUBLIC_URL + "/images/Default.png"
                                        //                 // }" style="cursor: move;"/>`;
                                        // modifyText("insertHTML", videoHTMLStr);
                                        onClickVideoIcon && onClickVideoIcon();
                                    } }, { children: _jsx(VideoCameraBackRoundedIcon, {}) })) })), _jsx(Tooltip, __assign({ arrow: true, title: "Add Audio" }, { children: _jsx(IconButton, __assign({ disabled: !rawHTMLToggleChecked || imgIsCurrentlySelected, 
                                    // disabled={true}
                                    id: "add-audio", sx: {
                                        borderRadius: "3px",
                                        marginRight: "4px",
                                        width: "".concat(buttonsPxSize, "px"),
                                        height: "".concat(buttonsPxSize, "px"),
                                    }, onClick: function (e) {
                                        onClickAudioIcon && onClickAudioIcon();
                                    } }, { children: _jsx(AudioFileRoundedIcon, {}) })) })), _jsx(Divider, { sx: { marginLeft: "5px", marginRight: "8px" }, orientation: "vertical", flexItem: true }), _jsx(Box, __assign({ component: "div", sx: { marginLeft: "-19px" } }, { children: _jsx(Tooltip, __assign({ arrow: true, title: rawHTMLToggleChecked ? "Edit Raw HTML" : "Edit Content" }, { children: _jsx(Switch, { disabled: imgIsCurrentlySelected, sx: { transform: "rotate(90deg)" }, onChange: function (event) {
                                            deselectImage();
                                            setRawHtml(encodeCharacterEscapedHTML(editAreaRef.current.innerHTML));
                                            setRawHTMLToggleChecked(event.target.checked);
                                            if (!rawHTMLToggleChecked) {
                                                window.setTimeout(function () {
                                                    attachImgEventHandlers();
                                                });
                                            }
                                        }, checked: rawHTMLToggleChecked }) })) }))] })), _jsxs(Box, __assign({ component: "div", sx: { display: "flex", alignItems: "center", padding: "5px", marginRight: "3px" } }, { children: [save && (_jsx(Tooltip, __assign({ arrow: true, title: "save changes" }, { children: _jsx(IconButton, __assign({ disabled: save.disable, 
                                    // disabled={true}
                                    id: "save-changes", sx: {
                                        borderRadius: "3px",
                                        marginRight: "4px",
                                        width: "".concat(buttonsPxSize, "px"),
                                        height: "".concat(buttonsPxSize, "px"),
                                    }, onClick: function (e) {
                                        save.onSave();
                                    } }, { children: _jsx(SaveRoundedIcon, {}) })) }))), cancel && (_jsx(Tooltip, __assign({ arrow: true, title: "cancel changes" }, { children: _jsx(IconButton, __assign({ disabled: cancel.disable, 
                                    // disabled={true}
                                    id: "cancel-changes", sx: {
                                        borderRadius: "3px",
                                        marginRight: "4px",
                                        width: "".concat(buttonsPxSize, "px"),
                                        height: "".concat(buttonsPxSize, "px"),
                                    }, onClick: function (e) {
                                        cancel.onCancel();
                                    } }, { children: _jsx(CancelRoundedIcon, {}) })) })))] }))] })), _jsx(Box, __assign({ onClick: function () {
                    moveCursorToEnd(richTextEditorId.current);
                }, onInput: function (e) {
                    // console.log("OUTER ON INPUT FIRED");
                    // e.stopPropagation();
                    // e.preventDefault();
                }, onDragOver: function (e) {
                    if (!mouseOverContentEditableAreaRef.current) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }, onDrop: function (e) {
                    // console.log("ON DROP OUTER FIRED");
                    if (!mouseOverContentEditableAreaRef.current) {
                        if (e.dataTransfer.getData("mediaType") === "image") {
                            moveCursorToEnd(richTextEditorId.current);
                            modifyText("insertHTML", "<img src=\"".concat(currentlyDragging === null || currentlyDragging === void 0 ? void 0 : currentlyDragging.src, "\" draggable=\"true\"/>"));
                            moveCursorToEnd(richTextEditorId.current);
                        }
                        else if (e.dataTransfer.getData("mediaType") === "audio") {
                            moveCursorToEnd(richTextEditorId.current);
                            modifyText("insertHTML", "<img id=\"audio-drop-img\" />");
                            moveCursorToEnd(richTextEditorId.current);
                        }
                        else if (e.dataTransfer.getData("mediaType") === "video") {
                            moveCursorToEnd(richTextEditorId.current);
                            modifyText("insertHTML", "<img id=\"video-drop-img\" />");
                            moveCursorToEnd(richTextEditorId.current);
                        }
                    }
                }, component: "div", sx: {
                    overflowY: "auto",
                    overflowX: "hidden",
                    // display: "flex",
                    height: "calc(100% - (35px + ".concat(buttonsPxSize, "px))"),
                    // flex: 1,
                    // opacity: "0.5",
                    borderTop: "1px solid #555",
                    padding: "10px",
                    ":hover": {
                        cursor: "text",
                    },
                    // paddingBottom: "15px"
                    // background: "blue",
                } }, { children: rawHTMLToggleChecked ? (_jsx("div", { ref: editAreaRef, id: richTextEditorId.current, onBeforeInput: function () { }, onDragOver: function () {
                        mouseOverContentEditableAreaRef.current = true;
                    }, onDragLeave: function () {
                        mouseOverContentEditableAreaRef.current = false;
                    }, 
                    // onDragEnd={() => {
                    //     mouseOverContentEditableAreaRef.current = false;
                    // }}
                    onDrop: function (e) {
                        // console.log("ON DROP INNER FIRED");
                        onDropHandler();
                    }, onClick: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        deselectImage();
                        setSelectedAlignButtonOption(null);
                        setSelectedFormatOption(null);
                        setSelectedListOption(null);
                    }, onSelect: function (e) { }, onInput: function (e) {
                        // console.log("ON INPUT FIRED");
                        e.stopPropagation();
                        onDropHandler();
                        onChangeHandler();
                    }, dangerouslySetInnerHTML: { __html: removeRteContainerDivFromHTMLString(rawHtml) }, contentEditable: "true", style: {
                        // overflowY: "scroll",
                        width: "100%",
                        // height: "100%",
                        // padding: "5px",
                        // marginBottom: "20px",
                        // background: "blue",
                        outline: "none",
                    } })) : (_jsx("div", __assign({ ref: editAreaRef, id: richTextEditorId.current, onBeforeInput: function () { }, onDragOver: function () {
                        // mouseOverContentEditableAreaRef.current = true;
                    }, onDragLeave: function () {
                        // mouseOverContentEditableAreaRef.current = false;
                    }, onDrop: onDropHandler, onClick: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        deselectImage();
                        setSelectedAlignButtonOption(null);
                        setSelectedFormatOption(null);
                        setSelectedListOption(null);
                    }, onSelect: function (e) { }, onInput: function (e) {
                        onChangeHandler(true);
                    }, contentEditable: "true", style: {
                        // overflowY: "scroll",
                        width: "100%",
                        height: "100%",
                        padding: "5px",
                        outline: "none",
                    } }, { children: removeRteContainerDivFromHTMLString(rawHtml) }))) }))] })));
}
